<template>
  <div class="p-2 h-full flex flex-col transition-[width] duration-300"
    :class="{ 'w-20': collapsed, 'w-64': !collapsed }">
    <div class="px-4 py-3 bg-surface-light h-full rounded flex flex-col gap-3 flex-1">

      <!-- Logo -->
      <div class="border-b border-neutral-200 pb-3 flex justify-center transition-all duration-300">
        <img :src="collapsed ? '/img/mini_logo.svg' : '/img/big_full_logo.svg'" alt="CharterPlace Company"
          :class="collapsed ? 'w-8 h-8' : 'max-w-full'" />
      </div>

      <!-- Company Info -->
      <div class="flex flex-col items-center gap-3 pt-5 pb-4">
        <div class="p-2 bg-white rounded-lg shadow flex items-center justify-center overflow-hidden"
        :class="collapsed ? 'w-10 h-10' : 'w-36 h-12'">
          <FallbackImg :src="collapsed ? companySmallLogo: companyLogo || ''" :alt="companyId" :fallback="defaultImage"
            class="max-w-full max-h-full object-contain" />
        </div>

        <div class="text-center text-sm transition-opacity duration-300"
          :class="collapsed ? 'opacity-0 invisible delay-0' : 'opacity-100 visible delay-300'">
          <p class="text-base">{{ companyName }}</p>
          <p class="text-[10px] text-light uppercase">{{ companyType }}</p>
        </div>
      </div>

      <!-- Sidebar Items -->
      <div class="pt-4 flex flex-col gap-2 flex-1">
        <SideBarItem v-for="item in sidebarItems" :key="item.label" :icon="item.icon" :label="item.label"
          :badge="item.badge" :collapsed="collapsed" :to="item.to" />
      </div>

      <!-- Bottom Buttons -->
      <div class="border-t border-neutral-200 pt-4 flex flex-col gap-2">
        <SideBarItem icon="lifesaver" label="Help center" :collapsed="collapsed" @click="handleHelpClick" />
        <SideBarItem icon="gear" label="Settings" :collapsed="collapsed" @click="handleSettingsClick" />
      </div>

      <!-- Collapse Button -->
      <div class="border-t border-neutral-200 pt-4 flex" :class="collapsed ? 'justify-center' : 'justify-end'">
        <button @click="collapsed = !collapsed" class="text-light hover:text-primary">
          <i :class="collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
        </button>
      </div>

    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import SideBarItem from "@/components/atoms/SideBarItem.vue";
import { useAuthStore } from "@/stores";
import { showInfo } from "@/common/functions.js";
import FallbackImg from "@/components/atoms/FallbackImg.vue";

const props = defineProps({
  companyType: { String, default: 'admin' }
})

const auth = useAuthStore();
const collapsed = ref(false);
const sidebarItems = defineModel('sidebarItems');
const companyType = computed(() => props.companyType)
const defaultImage = computed(() => {
  if (companyType.value === 'charterer') return '/img/default_charter.svg'
  if (companyType.value === 'airline') return '/img/default_airline.svg'
  return '/img/default_admin.svg'
})
const companyData = computed(() => (auth.user ?? {})[companyType.value] ?? {})
const companyId = computed(() => companyData.value.id ?? 'CPs')
const companyName = computed(() => companyData.value.name ?? 'CharterPlace')
const companyLogo = computed(() => companyData.value.logo ?? defaultImage.value)
const companySmallLogo = computed(() => companyData.value.small_logo ?? companyData.value.logo ?? defaultImage.value)
const handleHelpClick = () => showInfo("Work in progress")
const handleSettingsClick = () => showInfo("Work in progress")
</script>